
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo",
      function () {
        return require("private-next-pages/en/docs/komodo/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo"])
      });
    }
  